import { connect } from 'react-redux'
import TextSlideEditDialog from './edit-dialog.jsx'
import {
  getSlide,
  getUpdateSlideRequest,
  getDeleteSlideRequest
} from '../../../../stores/presentation/presentation.selectors'
import {
  updateSlide,
  deleteSlide
} from '../../../../stores/presentation/presentation.actions'
import { errorHandler } from 'pobble-components/dist/error-handler'
import { getEditSlideDialog } from '../../../pages/lesson/builder/redux/builder.selectors.js'
import { closeEditSlideDialog } from '../../../pages/lesson/builder/redux/builder.actions.js'

const mapStateToProps = state => {
  const editSlideDialog = getEditSlideDialog(state)
  const slide = getSlide(state, editSlideDialog.slideId)
  if (!slide) return { modalOpened: false }
  const updateSlideRequest = getUpdateSlideRequest(state, slide.id)
  const deleteSlideRequest = getDeleteSlideRequest(state, slide.id)
  return {
    updating: updateSlideRequest.pending,
    deleting: deleteSlideRequest.pending,
    modalOpened: editSlideDialog.opened && editSlideDialog.type === 'Text',
    title: slide.title,
    text: slide.body,
    html: slide.html_body,
    id: slide.id
  }
}

const mapDispatchToProps = dispatch => ({ dispatch })

const mergeProps = (stateProps, { dispatch }, ownProps) => ({
  ...ownProps,
  ...stateProps,
  onClose: () => dispatch(closeEditSlideDialog()),
  onSubmit: values =>
    dispatch(
      updateSlide(stateProps.id, 'Text', {
        title: values.title,
        body: values.text,
        html_body: values.html
      })
    ).catch(errorHandler),
  onDelete: () => dispatch(deleteSlide(stateProps.id)).catch(errorHandler)
})

export default connect(
  mapStateToProps,
  mapDispatchToProps,
  mergeProps
)(TextSlideEditDialog)
